import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import Typography from 'ravenjs/lib/Typography';

import BROWSER_TITLES from 'constants/browserTitles';
import MESSAGES from 'constants/messages';
import { resetBrowserTitle, setBrowserTitle } from 'utils/browserTitles';

const AssessmentToolSuccessStyled = styled.div`
    padding: 1rem 2.19rem;
    width: 100%;

    ${({ theme }) => theme.media.down('md')`
        padding: 1rem;
    `};
`;

const AssessmentToolSuccess = () => {
    const location = useLocation();

    React.useEffect(() => {
        if (location.pathname === '/public/prospect/assessment-tool-success') {
            setBrowserTitle(
                BROWSER_TITLES.PUBLIC.PROSPECT.ASSESSMENT_TOOL_SUCCESS,
                BROWSER_TITLES.PUBLIC.PROSPECT.SECTION
            );
        }

        return resetBrowserTitle;
    }, [location.pathname]);

    return (
        <AssessmentToolSuccessStyled>
            <Typography fontSize="3rem">
                {MESSAGES.PROSPECT_ASSESSMENT_TOOL.RESULTS_TITLE}
            </Typography>
            <Typography fontSize="1.5rem">{MESSAGES.PROSPECT_ASSESSMENT_TOOL.SUCCESS}</Typography>
        </AssessmentToolSuccessStyled>
    );
};

export default AssessmentToolSuccess;
